export default __webpack_public_path__ + "static/principles-of-use-do-light-1c5a1d0deae201a57fd3b446d7067f05.png";